<template>
  <div class="row q-col-gutter-sm">
    <div class="col-xs-12 col-md-6">
      <div class="text-h6">
        Colonnes
      </div>
      <draggable
        v-model="columns"
        ghost-class="bg-secondary"
        handle=".handle"
      >
        <transition-group
          tag="sortable-list"
          type="transition"
          name="flip-list"
          :props="{test: 'test'}"
        >
          <q-item
            v-for="column in columns"
            :key="column.name"
            class="hoverable"
          >
            <q-item-section avatar>
              <lwf-checkbox v-model="column.visible" />
            </q-item-section>
            <q-item-section>
              <q-item-label>
                {{ column.label }}
              </q-item-label>
            </q-item-section>
            <q-item-section side>
              <div>
                <q-btn
                  v-if="column.sortable"
                  flat
                  round
                  icon="fa fa-arrow-up"
                  class="q-mt-xs"
                  dense
                  :class="{
                    'sort-icon': value.pagination.sortBy !== column.name,
                    'rotate-180': value.pagination.descending
                  }"
                  @click="sortBy(column.name)"
                />
                <q-icon
                  right
                  name="fa fa-grip-vertical"
                  size="sm"
                  class="handle"
                />
              </div>
            </q-item-section>
          </q-item>
        </transition-group>
      </draggable>
    </div>
    <div class="col-xs-12 col-md-6">
      <div class="text-h6">
        Tableau
      </div>
      <q-select
        v-model="value.pagination.rowsPerPage"
        :options="$options.DATATABLE_ROWS_PER_PAGE_OPTIONS"
        label="Nombre de résultats par pages"
      />
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import formMixin from '@/mixins/formMixin'
import LwfCheckbox from 'components/core/LwfCheckbox'
import { DATATABLE_ROWS_PER_PAGE_OPTIONS } from '@/consts/app'

export default {
  name: 'FormDashboardConfigTable',
  components: { LwfCheckbox, draggable },
  mixins: [formMixin],
  inheritAttrs: false,
  DATATABLE_ROWS_PER_PAGE_OPTIONS,
  props: {
    defaultColumns: {
      type: Array,
      default: _.stubArray
    }
  },
  data () {
    return {
      columns: []
    }
  },
  watch: {
    columns: {
      deep: true,
      handler (columns) {
        this.$set(this.value, 'columns', columns.filter((c) => c.visible).map((c) => c.name))
      }
    }
  },
  created () {
    const indexed = _.keyBy(this.defaultColumns, 'name')
    this.columns = _.unionBy(
      (this.value.columns).map((c) => ({
        ...indexed[c],
        visible: true
      })),
      this.defaultColumns,
      'name'
    )
  },
  methods: {
    sortBy (k) {
      if (this.value.pagination.sortBy === k) {
        this.$set(this.value.pagination, 'descending', !this.value.pagination.descending)
      }
      this.$set(this.value.pagination, 'sortBy', k)
    }
  }
}
</script>

<style scoped lang="stylus">
.hoverable .sort-icon
  display none

.hoverable:hover .sort-icon
  display inline
</style>
